import { useGetContactCollectionByFirebaseEventIdOrCreateOneQuery } from '@graphql/generated';

export const useGuestListController = (firebaseEventId: string) => {
  const { data, loading } = useGetContactCollectionByFirebaseEventIdOrCreateOneQuery({
    variables: {
      firebaseEventId
    },
    batchMode: 'fast'
  });

  return {
    isLoading: loading,
    contactCollectionId: data?.getContactCollectionByFirebaseEventIdOrCreateOne?.id
  };
};
